// src/api/companyApi.js
import axios from 'axios';
import { getAuthHeaders } from './userController';

// URL base de la API
const BASE_URL = 'https://yokomo.api.ikeytechnologies.com/companies/'; // Cambia esta URL según tu configuración

// Función para obtener todas las empresas
export const fetchCompanies = async () => {
  try {
    const response = await axios.get(BASE_URL,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener las empresas:', error);
    throw error;
  }
};

// Función para obtener una empresa específica
export const fetchCompany = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}${id}/`,getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener la empresa:', error);
    throw error;
  }
};



// Función para actualizar una empresa
export const updateCompany = async (id, companyData) => {
  try {
    const formData = new FormData();

    // Agregar los datos al formData
    Object.keys(companyData).forEach((key) => {
      if (companyData[key] !== undefined && companyData[key] !== null) {
        formData.append(key, companyData[key]);
      }
    });

    // Hacer la solicitud PUT con FormData y los headers de autorización
    const response = await axios.put(`${BASE_URL}${id}/update/`, formData, {
      ...getAuthHeaders(), // Extiende los headers de autorización
      headers: {
        ...getAuthHeaders().headers,
        'Content-Type': 'multipart/form-data', // Especificamos el tipo de contenido
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error al actualizar la empresa:', error);
    throw error;
  }
};



